import { __exportAll } from "../../chunks/_virtual/_rolldown/runtime.js";
// src/utils/sentry/lazy-sentry.ts
var lazy_sentry_exports = /* @__PURE__ */ __exportAll({
	captureException: () => captureException,
	captureMessage: () => captureMessage,
	setUser: () => setUser
});
var sentryPromise;
function loadSentry() {
	return sentryPromise ??= import("@sentry/react");
}
function captureException(...args) {
	loadSentry().then((Sentry) => Sentry.captureException(...args));
}
function captureMessage(...args) {
	loadSentry().then((Sentry) => Sentry.captureMessage(...args));
}
function setUser(...args) {
	loadSentry().then((Sentry) => Sentry.setUser(...args));
}
export { captureException, captureMessage, lazy_sentry_exports, setUser };

//# sourceMappingURL=lazy-sentry.js.map